"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountingTableConf = void 0;
var end2end_1 = require("@hudled/end2end");
var formatRelative_1 = __importDefault(require("date-fns/formatRelative"));
var constants_1 = require("containers/TableMaker/constants");
var StatusDropdown_1 = __importDefault(require("./StatusDropdown"));
var LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, SM = constants_1.CellSize.SM, XS = constants_1.CellSize.XS;
var renderDate = function (lastSync) { return lastSync && (0, formatRelative_1.default)(lastSync, new Date()); };
exports.accountingTableConf = {
    headersMap: {
        provider: 'Platform',
        tenantName: 'Organization',
        accUserEmail: 'Email',
        baseCurrency: 'Currency',
        firstSync: 'Connected',
        lastSync: 'Last Synced',
    },
    extractors: {
        firstSync: function (item) { var _a; return (_a = (item.specialConnectionType === 'RECHARGE_AF' ? item.contactsFirstSync : item.firstSync)) === null || _a === void 0 ? void 0 : _a.toDate(); },
        lastSync: function (item) { var _a; return (_a = (item.specialConnectionType === 'RECHARGE_AF' ? item.contactsLastSync : item.lastSync)) === null || _a === void 0 ? void 0 : _a.toDate(); },
        status: end2end_1.getIntConnStatus,
        provider: end2end_1.getNiceProvider,
    },
    cells: [
        { field: 'provider', cell: { width: MD } },
        { fields: ['tenantName', 'accUserEmail'], cell: { width: LG, growCell: true, offset: 'right' } },
        { field: 'baseCurrency', cell: { width: MD, textAlign: 'center' } },
        { field: 'firstSync', cell: { width: MD + 16 }, truncate: {}, renderField: renderDate },
        { field: 'lastSync', cell: { width: MD + 16 }, truncate: {}, renderField: renderDate },
        { field: 'status', cell: { width: SM + XS, textAlign: 'right' }, renderComponent: StatusDropdown_1.default },
    ],
};
